var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-slider-container"},[_c('div',{staticClass:"tabs"},_vm._l((_vm.computedOptions),function(option){return _c('div',{key:option.value,class:['tab', { 'tab-selected': _vm.selectedTab === option.value }],on:{"click":function($event){return _vm.selectTab(option.value)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }